<template>
  <div class="error-boundary">
    <p>👁️👁</p>
    <p>В этом блоке ошибка!</p>
    <div v-if="error.message">
      <p>{{ error.message }}</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  error: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.error-boundary {
  display: flex;
  flex-direction: column;
  padding: 70px;
  border-radius: 16px;
  max-width: 1100px;
  border: 10px darkred solid;
  color: darkred;
  margin: 0 auto;
  font-size: 45px;
  text-align: center;
}
</style>
